module.exports = __webpack_public_path__ + "img/ChinaMobile.6a41b017.png";